export const CATEGORY_INVALID_FUNCTION_CALL = 1
export const CATEGORY_INVALID_FUNCTION_ARGUMENTS = 2
export const CATEGORY_EXECUTION_EXCEPTION = 3
export const CATEGORY_ACTION_NOT_GRANTED = 4
export const CATEGORY_TIMEOUT= 5